import placeholder from '@/shared/assets/images/atmoPlaceholder.webp'
import VodDetails from '@/features/VOD/vodClasses/vodDetails'

export const getVodAssetTypeViewStyles = (details: VodDetails) => {
    const mainContainerStyle = {
        position: 'relative',
        height: 'calc(100% - 64px)',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: { xs: '16px', md: '64px' },
        overflow: 'auto',
    }

    const atmosphericStyle = {
        position: 'absolute',
        zIndex: 0,
        width: '100vw',
        height: '100%',
        backgroundImage: `linear-gradient(to bottom, transparent 50%, black),
        ${
            details?.atmosphericUrl
                ? `url(${details?.atmosphericUrl})`
                : `url(${placeholder})`
        }`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
    }
    const contentStyle = {
        paddingTop: { xs: '8px', md: '16px' },
        height: 'max-content',
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        columnGap: { xs: '32px', md: '64px' },
    }

    const posterStyle = {
        maxHeight: {
            xs: '260px',
            sm: '350px',
            md: '478px',
            lg: '500px',
            xl: '448px',
        },
        maxWidth: { xs: '160px', sm: '250px', md: '278px', lg: '300px' },
        width: '100%',
        height: '100%',
        borderRadius: '10px',
        overflow: 'hidden',
        '& > img': {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center',
        },
    }

    const leftBox = {
        display: 'flex',
        alignItems: 'flex-start',
    }
    const rightBox = {
        width: '50%',
        marginTop: { xs: '32px', sm: 0 },
    }
    const ageRatingContainer = {
        position: 'relative',
        zIndex: 1,
        mr: '55px',
        mt: '16px',
        display: 'flex',
        columnGap: '20px',
    }
    const controlButtonsStyles = {
        display: 'flex',
        gap: '20px',
        alignItems: 'center',
        marginBottom: '44px',
    }

    return {
        controlButtonsStyles,
        ageRatingContainer,
        atmosphericStyle,
        mainContainerStyle,
        contentStyle,
        posterStyle,
        leftBox,
        rightBox,
    }
}
